export const BEGIN_INTERRUPT_EXECUTION = 'BEGIN_INTERRUPT_EXECUTION';
export const END_INTERRUPT_EXECUTION = 'END_INTERRUPT_EXECUTION';
export const EVAL_INTERPRETER_ERROR = 'EVAL_INTERPRETER_ERROR';
export const EVAL_INTERPRETER_SUCCESS = 'EVAL_INTERPRETER_SUCCESS';
export const EVAL_TESTCASE_FAILURE = 'EVAL_TESTCASE_FAILURE';
export const EVAL_TESTCASE_SUCCESS = 'EVAL_TESTCASE_SUCCESS';
export const HANDLE_CONSOLE_LOG = 'HANDLE_CONSOLE_LOG';
export const BEGIN_DEBUG_PAUSE = 'BEGIN_DEBUG_PAUSE';
export const END_DEBUG_PAUSE = 'END_DEBUG_PAUSE';
export const DEBUG_RESUME = 'DEBUG_RESUME';
export const DEBUG_RESET = 'DEBUG_RESET';
export const HIGHLIGHT_LINE = 'HIGHLIGHT_LINE';
